import '../scss/pfields/Pselect.scoped.scss';
import '../scss/pfields/Pselect.scss'
import Select, { components } from 'react-select';
import {useState, useEffect, useCallback, useRef} from "react";

function Pselect({clearSel, addSelRefs, pfield, dcheck, myAppRef}) {
  const myRef = useRef();
  const name = "r" + pfield.id;
  const [oldHeight,setOldHeight] = useState(null);
  let svalue = pfield.obj.querySelector('select').value;
  let sid = name;
  let sol = [...pfield.obj.querySelector('select').options];
  const options = sol.map((opt) => {
    return {value: opt.value, label: opt.label}
  });
  let selVal = null;
  if(svalue) {
    selVal = options.filter((optf) => optf.value === svalue)[0];
  }
  const [mvalue, setMValue] = useState(selVal);
  let classes = ["pfield"];
  if(pfield.dependent) {
    classes.push("hidden");
  }
  if(pfield.error) {
    classes.push("error");
  }
  classes = classes.concat(pfield.eclasses);

  let wcls = [];
  if(window.pd_sec_dependency) {
    window.pd_sec_dependency.forEach((secDep) => {
      if(secDep.condition.type === "change" && 
      secDep.condition.action === "clear") { 
        if(classes.includes(secDep.primary)) {
          wcls.push(secDep.secondary);
        }
        if(classes.includes(secDep.secondary)) {
          let tro = {cname: secDep.secondary, ref: myRef};
          addSelRefs(tro);
        }
      }
    });
  }
  const [clearClass, setClearClass] = useState(wcls);
  const updatePardot = (f) => {
    setMValue(f);
    let o = document.querySelector(`#p-content select[name="${name.substring(1)}"]`);
    if(o) {
      if(f) {
        o.value = f.value
      } else {
        o.value= "";
      }
    } else {
      console.log(">>> " + name);
    }
    // check for clear
    if(clearClass.length > 0){
      clearClass.forEach((cl) => {
       let clo = document.querySelector("." + cl);
       if(clo) {
        clearSel(cl);
       }
      });
    }
    let m = {
      name: name,
      value: f ? f.value : "",
      label: f ? f.label : ""
    };
    dcheck(m);
  }

  const checkFunct = useCallback(() => {
    if(mvalue) {
      let m = {
        name: name,
        value: mvalue.value,
        label: mvalue.label
      };
      dcheck(m);
    }  
  }, [name, mvalue, dcheck]);

  const optionDisabled = (o) => {
    let rtn = false;
    if(o.label && 
      o.label.trim().length > 0 && 
      window.pd_sec_dependency) {
      let pClassList = [...document.querySelector('#d'+name.substring(1)).classList];
      let sec = window.pd_sec_dependency.filter((s) => {
        return pClassList.includes(s.secondary);
      });
      if(sec.length > 0) {
        sec.forEach((s) => {
          if(s.condition.type === "filterOptions" && 
             s.condition.action === "hide") {
              let pvo = document.querySelector(".drform ." + s.primary + " .sc-dropdown__single-value");
              if(pvo) {
                let pv = pvo.innerHTML;
                if(pv){
                  if(s.condition.primaryValues
                    .map((b) => {return b.trim().toLowerCase()})
                    .includes(pv.trim().toLowerCase())) {
                    rtn = s.condition.secondaryValues
                      .map((a) => {return a.trim().toLowerCase()})
                      .includes(o.label.trim().toLowerCase());
                  }
                }
              }
             }
        });
      }
    }
    return rtn;
  }

  const checkAppHeight = (times) => {
    let ah = myAppRef.current.offsetHeight;
    let dsh = document.body.scrollHeight; 
    if(ah < dsh) {
      dsh += 10;
      setOldHeight(myAppRef.current.style.minHeight);
      myAppRef.current.style.minHeight = "" + dsh + "px";
    } else {
      if(times) {
        window.setTimeout(() => {
          checkAppHeight(times-1);
        },100);
      }
    }
  }

  const menuOpened = () => {
    let o = document.querySelector(`#${sid}`);
    if(o && !o.classList.contains('menu-open')) {
      o.classList.add('menu-open');
    }
    window.setTimeout(() => {
      checkAppHeight(10);
    },100);
  }

  const menuClosed = () => {
    let o = document.querySelector(`#${sid}`);
    if(o && o.classList.contains('menu-open')) {
      o.classList.remove('menu-open');
    }
    myAppRef.current.style.minHeight = oldHeight;
  }

  useEffect(() => {
    checkFunct();
  },[checkFunct]);

  const DropdownIndicator = (
    props
  ) => {
    return (
      <components.DropdownIndicator {...props}>
        <svg viewBox="0 0 17 10" className="sc-arrow-svg">
          <polygon className="down" points="0,0 17,0 9,10"/>
          <polygon className="up" points="0,10 17,10 9,0"/>
        </svg>
      </components.DropdownIndicator>
    );
  };


  return(
    <div className={classes.join(' ')} id={'d' + pfield.id} >
      {pfield.error ? <p>{pfield.errtxt}</p> : "" }
      <Select 
        ref={myRef}
        className="sc-dropdown" 
        classNamePrefix="sc-dropdown" 
        id={sid} 
        name={sid} 
        placeholder={pfield.label} 
        onChange={updatePardot} 
        onMenuOpen={menuOpened}
        onMenuClose={menuClosed}
        options={options}
        isOptionDisabled={optionDisabled}
        components={{ DropdownIndicator }}
        value={mvalue}
        defaultValue={mvalue}>
      </Select>
    </div>
  );

}

export default Pselect;